import { render, staticRenderFns } from "./VisaCheckoutPay.vue?vue&type=template&id=82258c7c"
import script from "./VisaCheckoutPay.vue?vue&type=script&lang=js"
export * from "./VisaCheckoutPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports